import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

// Format date utility function
export function formatDate(date: any) {
	let dateFormat;
	let timeFormat;

	let d = new Date(date),
		month = '' + (d.getMonth() + 1),
		day = '' + d.getDate(),
		year = d.getFullYear(),
		hour = '' + d.getHours(),
		minute = '' + d.getMinutes(),
		seconds = '' + d.getSeconds();

	if (month.length < 2) month = '0' + month;
	if (day.length < 2) day = '0' + day;
	if (hour.length < 2) hour = '0' + hour;
	if (minute.length < 2) minute = '0' + minute;
	if (seconds.length < 2) seconds = '0' + seconds;

	dateFormat = [year, month, day].join('-');
	timeFormat = [hour, minute, seconds].join(':');

	return dateFormat + ' ' + timeFormat;
}

// Handle module selection utility
export const handleSelectModule = (moduleId: number, navigate: ReturnType<typeof useNavigate>, handleToggle?: () => void) => {
	switch (moduleId) {
		case 6:
			navigate('/mro-reports');
			break;
		case 7:
			navigate('/nrw');
			break;
		case 8:
			if (handleToggle) {
				handleToggle();
			}
			break;
		case 9:
			navigate('/mms');
			break;
		case 10:
			navigate('/simulations');
			break;
		default:
		// console.log('No action defined for this module.');
	}
};